import Vue from 'vue';
if (document.getElementById('organization')) {
    let organization = new Vue({
        el: '#organization',
        data: {
            organization: {},
            load: false,
            lectors:{},
            page: 1,
            pageCount: 0
        },
        mounted: function () {
            this.fetchOrganization();
            this.fetchLectors();
        },
        methods: {
            fetchOrganization: function () {
                var self = this;

                this.load = true;

                try {
                    $.ajax({
                        url: '/api/v1/organization/view',
                        dataType: "json",
                        data: {id: organizationId},
                        success: function (data) {
                            self.organization = data.item;
                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });

                } catch (e) {
                    console.error(e);
                }
            },
            fetchLectors: function () {
                var self = this;

                $.ajax({
                    url: '/api/v1/lector',
                    dataType: "json",
                    data: {'schedule': 1, organization_id: organizationId},
                    success: function (data) {

                        self.lectors = data;
                    },
                    fail: function () {
                        throw new Error('Ошибка получении данных');
                    }
                });
            },
        }
    });
}